// extracted by mini-css-extract-plugin
export default {"container":"GalleryTitle_container__8Bbwv","title":"GalleryTitle_title__cJXkw","fadeInBottomLeft":"GalleryTitle_fadeInBottomLeft__1Fn11"};